export default function initFaq() {
  const faqWrappers = document.querySelectorAll(".faq-wrapper");

  if (!faqWrappers.length) return;

  faqWrappers.forEach((wrapper) => {
    const faqItems = wrapper.querySelectorAll(".faq-item");

    faqItems.forEach((item) => {
      const title = item.querySelector(".faq-title");
      const content = item.querySelector(".faq-content");

      if (!title || !content) return;

      // Initialize: if already has is-active, set max-height to none
      // This allows dynamic content and avoids height calculation issues
      if (item.classList.contains("is-active")) {
        content.style.maxHeight = "none";
      }

      title.addEventListener("click", () => {
        const isActive = item.classList.contains("is-active");

        if (isActive) {
          // Closing current item
          content.style.maxHeight = content.scrollHeight + "px";
          // Force reflow
          content.offsetHeight;
          content.style.maxHeight = "0";
          item.classList.remove("is-active");
        } else {
          // Close other open items in this wrapper
          faqItems.forEach((otherItem) => {
            if (otherItem !== item && otherItem.classList.contains("is-active")) {
              const otherContent = otherItem.querySelector(".faq-content");
              if (otherContent) {
                otherContent.style.maxHeight = otherContent.scrollHeight + "px";
                // Force reflow
                otherContent.offsetHeight;
                otherContent.style.maxHeight = "0";
              }
              otherItem.classList.remove("is-active");
            }
          });

          // Open current item
          content.style.maxHeight = "0";
          // Force reflow
          content.offsetHeight;
          item.classList.add("is-active");
          content.style.maxHeight = content.scrollHeight + "px";

          // After transition, set to none to allow dynamic content
          content.addEventListener(
            "transitionend",
            () => {
              if (item.classList.contains("is-active")) {
                content.style.maxHeight = "none";
              }
            },
            { once: true }
          );
        }
      });

      // Make title focusable and handle keyboard
      title.setAttribute("tabindex", "0");
      title.setAttribute("role", "button");
      title.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          title.click();
        }
      });
    });

    // Mark wrapper as ready to enable transitions
    wrapper.classList.add("is-ready");
  });
}
